// Sign-out asks sync to push pending edits first (WEB_PLAN.md §4.6). sync/ registers the flusher while a company is
// open; auth/ calls `flushPending` before `supabase.auth.signOut()`. This file keeps the two packages decoupled.

export interface FlushResult {
  /** Edits that could not be pushed in time (0 = everything saved). */
  unsaved: number;
}

type Flusher = (timeoutMs: number) => Promise<FlushResult>;

let flusher: Flusher | null = null;

export function setPendingFlusher(fn: Flusher | null): void {
  flusher = fn;
}

export async function flushPending(timeoutMs = 5000): Promise<FlushResult> {
  if (!flusher) return { unsaved: 0 };
  try {
    return await flusher(timeoutMs);
  } catch {
    return { unsaved: 1 };
  }
}
